"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./DictionariesService"));
__export(require("./dictionaries/Dictionary"));
__export(require("./dictionaries/DictionaryItem"));
__export(require("./cache/DefaultDictionariesCacheService"));
//# sourceMappingURL=index.js.map